import { createFileRoute, useRouterState } from '@tanstack/react-router'
import { useDomain } from '../contexts/domain-provider';
import { useSuspenseQuery } from '@tanstack/react-query';
import DynamicZone from '../components/DynamicZone';
import ComponentDebugOverlay from '../components/debug/ComponentDebugOverlay';
import { getPageById } from '../data/data-layer';

export const Route = createFileRoute('/test')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => {
    // validate and parse the search params into a typed state
    return {
      id: String(search?.id ?? ""),
    }
  },
})

function RouteComponent() {
  const { id } = Route.useSearch();
  const { domain } = useDomain()
  const router = useRouterState();

  const { data } = useSuspenseQuery(getPageById(id, domain));

  const entity = data?.data?.[0];

  interface ConfiguredContentBlock {
    id: number;
    __component: string;
    editor_label?: string;
    html_id?: string;
    configuration?: any;
    content_block?: {
      id: number;
      documentId: string;
      name?: string;
      title?: string;
      elements?: any[];
    };
  }

  if (entity) {
    return <>
      {(entity?.configured_content_blocks as ConfiguredContentBlock[] | undefined)?.map((e, i) => {
        const blockTitle = e.content_block?.name || e.content_block?.title;
        const pageAdminUrl = entity.documentId
          ? `https://cms.purebotswana.com/admin/content-manager/collection-types/api::page.page/${entity.documentId}`
          : undefined;
        const content = (
          <ComponentDebugOverlay
            key={i}
            label="ConfiguredContentBlock"
            title={e.editor_label}
            adminUrl={pageAdminUrl}
          >
            <DynamicZone
              title={blockTitle}
              elements={e.content_block?.elements}
              configuration={e.configuration}
              contentBlockDocumentId={e.content_block?.documentId}
              pageDocumentId={entity.documentId}
            />
          </ComponentDebugOverlay>
        );
        return e.html_id ? (
          <div id={e.html_id} key={i}>
            {content}
          </div>
        ) : (
          content
        );
      })}
    </>
  }

  return (
    <div style={{ padding: "1em" }}>
      <p>
        Requested resource `{router.location.pathname}` not found. Redirecting
        to the <a href="/">main page</a>.
      </p>
    </div>
  );
}
